<template>
    <div class="floor_info">
        <swiper ref="swiper" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="content">
                        <div class="cover" :style="`background-image: url(${item.image});`">
                            <img :src="item.image" alt="" :preview="`floor_${index}`"/>
                        </div>
                        <div class="text">
                            <p class="p1">{{item.name}}</p>
                            <p class="p2">{{item.name_en}}</p>
                            <p class="p3">{{item.unit}}</p>
                            <div class="text_group">
                                <div class="item">
                                    <div class="title">建筑面积(GFA):</div>
                                    <div class="desc">
                                        <p v-for="(_item, _index) in item.built_area" :key="_index">{{_item}}</p>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="title">标准层高度(净高):</div>
                                    <div class="desc">
                                        <p>Clear height of standard floor :</p>
                                        <p v-for="(_item, _index) in item.standard_height" :key="_index">{{_item}}</p>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="title">架空地板高度</div>
                                    <div class="desc">
                                        <p>Height of raised floor:</p>
                                        <p v-for="(_item, _index) in item.elevated_height" :key="_index">{{_item}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="btn_group">
                                <a class="btn" v-if="item.vr_link" :href="item.vr_link" target="_blank">VR看房</a>
                                <router-link class="btn" :to="`detail/${item.id}`" append>了解更多</router-link>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "floorInfo",
    props: [ 'data' ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.floor_info .swiper-button-prev',
                    nextEl: '.floor_info .swiper-button-next',
                },
                observer: true,
                observeParents: true,
                autoHeight: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {
    },
    destroyed() {},
    watch: {
        data(){
            // 数据变动后，轮播图切换到第一个
            this.swiper.slideTo(0, 0);
        }
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.floor_info{
    position: relative;
    .swiper-slide{
        display: flex;
        flex-direction: row-reverse;
    }
    .content{
        padding: .25rem 0;
        background: #e6e6e6;
        border-radius: .04rem;
        width: 9.6rem;
        display: flex;
        .cover{
            margin-left: -2.4rem;
            width: 5.3rem;
            height: 4.8rem;
            border: 1px solid #cecece;
            border-radius: .04rem;
            background: #fff no-repeat center/cover;
            img{
                width: 100%;
                height: 100%;
                opacity: 0;
                cursor: pointer;
            }
        }
        .text{
            flex: 1;
            line-height: 1.6;
            padding: 0 .7rem;
            .p1{
                font-size: .26rem;
                margin-top: .2rem;
            }
            .p3{
                font-size: .2rem;
                margin-bottom: .2rem;
            }
            .text_group{
                display: flex;
                flex-wrap: wrap;
                .item{
                    width: 50%;
                    margin-bottom: .3rem;
                    .title{
                        font-weight: bold;
                    }
                }
            }
            .btn_group{
                display: flex;
                justify-content: flex-end;
                .btn{
                    width: .84rem;
                    height: .26rem;
                    border-radius: .04rem;
                    background: #7b7b7b;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: .4rem;
                }
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        background: no-repeat 0/100%;
        margin-top: -.15rem;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    @media only screen and (max-width: 1200px) {
        .content{
            width: 100%;
            display: block;
            padding: 0 1rem;
            .cover{
                width: 100%;
                height: 11.1rem;
                margin: 0 0 .8rem;
            }
            .text{
                padding: 0 0 1.2rem;
                .p1,
                .p2,
                .p3{
                    text-align: center;
                }
                .p1{
                    font-size: .6rem;
                    font-weight: bold;
                    margin: 0;
                }
                .p2{

                }
                .p3{
                    font-size: .36rem;
                }
                .text_group{
                    margin-top: 1.4rem;
                    .item{
                        margin-bottom: 1.2rem;
                    }
                }
                .btn_group{
                    justify-content: center;
                    .btn{
                        width: 2.9rem;
                        height: .9rem;
                        margin: 0 .7rem;
                    }
                }
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
            top: 12.52rem;
            margin-top: 0;
        }
        .swiper-button-prev{
            left: 1rem;
        }
        .swiper-button-next{
            right: 1rem;
        }
    }
}
</style>